import React from 'react';
import * as Yup from 'yup';
import MasterManager from '../../components/expense/MasterManager';
import useExpenseLookups, { withCurrent } from '../../components/expense/useExpenseLookups';
import { userLabel } from '../../services/expenseMastersApi';

const KINDS = [
  { value: 'corporate_card', label: 'Corporate Card' },
  { value: 'bank_account', label: 'Bank Account' },
  { value: 'invoice_arrangement', label: 'Invoice Arrangement' },
];
const kindLabel = (k) => KINDS.find((x) => x.value === k)?.label || k;

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required').max(100),
  kind: Yup.string().oneOf(KINDS.map((k) => k.value), 'Select a valid kind').required('Kind is required'),
});

// Owner: Accounts. Paid Via is the paying instrument - not Payment Type.
const PaidViaMaster = ({ canEdit }) => {
  const { currencies, users } = useExpenseLookups(canEdit ? ['currencies', 'users'] : []);

  return (
    <MasterManager
      resource="paidVia"
      title="Paid Via"
      canEdit={canEdit}
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'kind', label: 'Kind', render: (r) => kindLabel(r.kind) },
        { key: 'currency', label: 'Currency' },
        { key: 'holder', label: 'Holder', render: (r) => userLabel(r.holderUserId) },
        { key: 'legacyValues', label: 'Legacy (ERP) Values', render: (r) => (r.legacyValues || []).join(', ') },
      ]}
      fields={(editing) => [
        { name: 'name', label: 'Name', required: true },
        { name: 'kind', label: 'Kind', type: 'select', required: true, options: KINDS, xs: 6 },
        { name: 'currency', label: 'Currency', type: 'select', options: withCurrent(currencies, editing?.currency), xs: 6 },
        {
          name: 'holderUserId', label: 'Holder', type: 'autocomplete',
          options: withCurrent(users, editing?.holderUserId?._id, userLabel(editing?.holderUserId)),
        },
        { name: 'legacyValues', label: 'Legacy (ERP) values', helperText: 'Comma-separated values used in erp_expense' },
      ]}
      validationSchema={schema}
      emptyValues={{ name: '', kind: '', currency: '', holderUserId: '', legacyValues: '' }}
      toForm={(r) => ({
        name: r.name || '',
        kind: r.kind || '',
        currency: r.currency || '',
        holderUserId: r.holderUserId?._id || '',
        legacyValues: (r.legacyValues || []).join(', '),
      })}
      toPayload={(v) => ({
        name: v.name,
        kind: v.kind,
        currency: v.currency,
        holderUserId: v.holderUserId,
        legacyValues: v.legacyValues.split(',').map((s) => s.trim()).filter(Boolean),
      })}
    />
  );
};

export default PaidViaMaster;
